export const SYNC_EVERY_MIN = readIntMeta('checkin-sync-threshold-minutes', 2);
export const OFFLINE_MODE_ENABLED = readBoolMeta('checkin-offline-mode-enabled', true);
export const AUTH_URL = readMeta('checkin-auth-url') || '/checkin/login';
export const EVENT_ID = window.EVENT_ID;
export const DEVICE_UUID = window.DEVICE_UUID || '-';

export function isAuthenticated() {
    if (window.IS_AUTHENTICATED != null) return !!window.IS_AUTHENTICATED;
    const m = document.querySelector('meta[name="checkin-authenticated"]');
    return m ? m.content === 'true' : true;
}

export function redirectToAuth() {
    window.location.assign(AUTH_URL);
};

export function readMeta(name) {
    const m = document.querySelector(`meta[name="${name}"]`);
    return m ? m.content : null;
}
export function readIntMeta(name, d = 0) {
    const v = parseInt(readMeta(name) || '', 10);
    return Number.isFinite(v) ? v : d;
}
export function readBoolMeta(name, d = false) {
    const v = readMeta(name);
    if (v == null) return d;
    return v === 'true' || v === '1';
}
export function escapeHtml(s) {
    return String(s == null ? '' : s)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}